var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPamCloudLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3124 12.5473C23.8616 10.2178 22.6144 8.11756 20.7847 6.60677C18.955 5.09597 16.6568 4.26866 14.284 4.26666V6.30724C16.1822 6.30979 18.0206 6.97196 19.4844 8.18045C20.9483 9.38893 21.9466 11.0686 22.3086 12.932L22.5728 14.3053L23.9492 14.5553C25.3274 14.8047 26.5626 15.5604 27.4122 16.6739C28.2618 17.7874 28.6645 19.1783 28.5412 20.5735C28.4178 21.9686 27.7774 23.2673 26.7456 24.2145C25.7138 25.1617 24.3652 25.6889 22.9646 25.6928H14.284V27.7333H22.9646C24.8747 27.7292 26.7142 27.011 28.1219 25.7199C29.5295 24.4287 30.4035 22.6579 30.5723 20.7553C30.741 18.8527 30.1922 16.9557 29.0338 15.437C27.8754 13.9183 26.191 12.8876 24.3114 12.5473H24.3124Z",
    fill: "#40d088"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12177 23.6521H12.2435V25.6927H6.12177V23.6521Z",
    fill: "#40d088"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04059 23.6521H4.08117V25.6927H2.04059V23.6521Z",
    fill: "#40d088"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08118 19.571H12.2435V21.6116H4.08118V19.571Z",
    fill: "#40d088"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.571H2.04058V21.6116H0V19.571Z",
    fill: "#40d088"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12177 15.4899H12.2435V17.5304H6.12177V15.4899Z",
    fill: "#40d088"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04059 15.4899H4.08117V17.5304H2.04059V15.4899Z",
    fill: "#40d088"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16236 11.4087H12.2435V13.4492H8.16236V11.4087Z",
    fill: "#40d088"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08118 11.4087H6.12176V13.4492H4.08118V11.4087Z",
    fill: "#40d088"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.203 7.32755H12.2435V9.36812H10.203V7.32755Z",
    fill: "#40d088"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPamCloudLogo);
export default __webpack_public_path__ + "static/media/PAMCloudLogo.73b4214afcd0a8e35ffc2e04b2b1dceb.svg";
export { ForwardRef as ReactComponent };